import { SlideUpModal } from "src/components/SlideUpModal";

type DuplicateCoborrowerModalProps = {
  isOpen: boolean;
  borrowerName: string;
  closeHandler: () => void;
  confirmHandler: () => void;
  isLoading?: boolean;
};

export default ({
  isOpen,
  borrowerName,
  closeHandler,
  confirmHandler,
  isLoading,
}: DuplicateCoborrowerModalProps) => {
  const displayName = borrowerName.trim() || "This person";

  return (
    <SlideUpModal
      title="Duplicate borrower"
      subText={`${displayName} already has an application in progress. Are you sure you would like to create another?`}
      isOpen={isOpen}
      closeHandler={closeHandler}
      hasDismissButton={true}
      dismissButtonText="Cancel"
      actionButtonText="Confirm"
      actionButtonClickHandler={confirmHandler}
      isLoading={isLoading}
    />
  );
};
